//dashboardWidgetRegistry.config.ts
import type { DashboardWidgetRegistry } from "../DashboardWidgetRenderer";
import ApprovalRequiredPanel from "../alternative-components/approval/ApprovalRequiredPanel";
import RecentTransactionPanel from "../alternative-components/approval/RecentTransactionPanel";
import ApprovedTodayCard from "../alternative-components/cards/ApprovedTodayCard";
import CashAvailableCard from "../alternative-components/cards/CashAvailableCard";
import PendingApprovalsCard from "../alternative-components/cards/PendingApprovalsCard";
import RepairQueueCard from "../alternative-components/cards/RepairQueueCard";

export const DASHBOARD_WIDGET_REGISTRY: DashboardWidgetRegistry = {
  205: PendingApprovalsCard, // Pending Approval
  206: RepairQueueCard, // Repair Queue
  207: ApprovedTodayCard, // Approved Today
  61: CashAvailableCard, // Cash Available
  66: ApprovalRequiredPanel, // Approval Required
  64: RecentTransactionPanel, // Repair Transactions
};
